<template>
  <div style="height: 100%; text-align: left">
    <el-row style="height: 100%">
      <el-col :span="8" style="height: 100%">
        <!--实现上下两个部分，上面是线路，下面是线路关联的区域列表-->
        <div style="height: 50%; padding: 10px; box-sizing: border-box;">
          <RouteList ref="routeListRef" @addClick="openAddDialog" @rowClick="handleRouteRowClick"
            @editClick="openEditDialog" @deleteClick="deleteRoute" />

        </div>
        <div style="height: 50%; padding: 10px; box-sizing: border-box; border-top: 1px solid #eee;">
          <AreaList ref="areaListRef" :map="map" :areaList="allAreaList" :selectedRoute="selectedRoute" />

        </div>
      </el-col>
      <el-col :span="16" style="height: 100%">
        <div style="
            width: 100%;
            height: calc(100vh - 140px);
            background-color: #fff;
          ">
          <!-- 地图组件 -->
          <div class="map-container" style="height: 100%;height: 100%;">
            <KingLongMap ref="map" mapId="content_boc_area_map" @LoadCompleted="MapLoadCompleted" />
          </div>
        </div>
      </el-col>
    </el-row>

    <RouteEdit ref="routeEdit" @saveSuccess="handleSaveSuccess" />

  </div>
</template>
<script>
import KingLongMap from "@/components/KingLongMap.vue";
import RouteList from "./components/route_list.vue";
import AreaList from "./components/area_list.vue";
import RouteEdit from "./components/route_edit.vue";
import { queryAutoRouteAreaList, deleteAutoRouteInfo } from '@/http/vehicle'
export default {
  name: "BoCAdaptive_Area",
  components: {
    KingLongMap,
    RouteList,
    AreaList,
    RouteEdit,
  },
  data() {
    return {
      map: null,

      // 线路列表数据
      routeList: [

      ],

      // 选中的线路
      selectedRoute: null,
      // 所有区域列表数据
      allAreaList: [

      ],


      timeRange: [],
      // 轨迹提取的区域列表
      extractedAreaList: [],

      // 区域对话框相关数据
      areaDialogVisible: false,
      areaDialogLoading: false,
      areaDialogTitle: '',
      isAreaEdit: false,


    };
  },

  watch: {


  },
  methods: {
    handleSaveSuccess() {
      //线路新增成功
      //刷新线路列表
      this.$refs.routeListRef.loadRouteList();
    },
    MapLoadCompleted() {
      this.map = this.$refs.map;
    },


    // 线路行点击事件
    handleRouteRowClick(row) {
      this.selectedRoute = row;
      //加载线路对应的区域列表，并传递给区域列表组件
      this.loadAreaList();
    },
    loadAreaList() {

      queryAutoRouteAreaList({
        routeID: this.selectedRoute.routeID,
      }).then(res => {

        if (res.code === 200) {
          this.$refs.areaListRef.setAreaList(res.data.areaInfo.areaList || []);

        }
      });
    },
    // 清空选择线路
    clearSelectedRoute() {
      this.selectedRoute = null;
    },

    // 打开新增线路对话框
    openAddDialog() {

      this.$refs.routeEdit.add()


    },
    // 打开编辑线路对话框
    openEditDialog(row) {
      this.$refs.routeEdit.edit(row)

    },
    // 删除线路
    deleteRoute(row) {
      this.$confirm(`确定要删除线路 "${row.routeName}" 吗？`, '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(row.routeID)
        deleteAutoRouteInfo(row.routeID).then(res => {
          if (res.code === 200) {
            this.$message.success('线路删除成功');
            // 刷新线路列表
            this.$refs.routeListRef.loadRouteList();
          } else {
            this.$message.error('删除线路失败');
          }
        })

      }).catch(() => {
        // 取消删除
      });
    },


  },
}
</script>
<style scoped>
/* 空区域提示样式 */
.empty-area {
  margin-top: 20px;
  text-align: center;
}

/* 对话框底部按钮样式 */
.dialog-footer {
  text-align: right;
  margin-top: 20px;
}
</style>